import { render, staticRenderFns } from "./TheRegistration.vue?vue&type=template&id=25564085&scoped=true&"
import script from "./TheRegistration.vue?vue&type=script&lang=js&"
export * from "./TheRegistration.vue?vue&type=script&lang=js&"
import style0 from "./TheRegistration.vue?vue&type=style&index=0&id=25564085&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25564085",
  null
  
)

export default component.exports